import React from 'react';
import { Mail, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = ({ language }) => {
  const texts = {
    en: {
      company: 'CookingAI365',
      tagline: 'Your AI-powered cooking assistant',
      quickLinks: 'Quick Links',
      support: 'Support',
      legal: 'Legal',
      contact: 'Contact Us',
      address: 'Portugal',
      email: 'support@cookingai365.com',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      cookies: 'Cookies',
      home: 'Home',
      features: 'Features',
      howItWorks: 'How It Works',
      benefits: 'Benefits'
    },
    pt: {
      company: 'CookingAI365',
      tagline: 'Seu assistente de culinária alimentado por IA',
      quickLinks: 'Links Rápidos',
      support: 'Suporte',
      legal: 'Legal',
      contact: 'Entre em Contato',
      address: 'Portugal',
      email: 'suporte@cookingai365.com',
      rights: 'Todos os direitos reservados.',
      privacy: 'Política de Privacidade',
      terms: 'Termos e Condições',
      cookies: 'Cookies',
      home: 'Início',
      features: 'Recursos',
      howItWorks: 'Como Funciona',
      benefits: 'Benefícios'
    }
  };

  const t = texts[language];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-green-400">{t.company}</h3>
            <p className="text-gray-300">{t.tagline}</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li><a href="#section-1" className="text-gray-300 hover:text-green-400 transition-colors duration-200">{t.home}</a></li>
              <li><a href="#section-2" className="text-gray-300 hover:text-green-400 transition-colors duration-200">{t.features}</a></li>
              <li><a href="#section-3" className="text-gray-300 hover:text-green-400 transition-colors duration-200">{t.howItWorks}</a></li>
              <li><a href="#section-4" className="text-gray-300 hover:text-green-400 transition-colors duration-200">{t.benefits}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-green-400" />
                <span className="text-gray-300">{t.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-green-400" />
                <span className="text-gray-300">{t.email}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              <p>© 2024 {t.company}. {t.rights}</p>
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy.html" className="text-gray-400 hover:text-green-400 transition-colors duration-200 text-sm">
                {t.privacy}
              </a>
              <a href="/terms.html" className="text-gray-400 hover:text-green-400 transition-colors duration-200 text-sm">
                {t.terms}
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200 text-sm">
                {t.cookies}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
